<template>
  <Layout>
    <DevHostSelect
      v-model="selectedHost"
      v-model:selectedBrand="selectedBrand"
    />
    <AntRow :gutter="20" class="content-row">
      <AntCol :span="24">
        <Instruction :platformList="platformList" />
      </AntCol>
      <AntCol :xs="24" :sm="24" :md="24" :lg="8" :xl="6">
        <ParameterForm :platformList="platformList" :testData="testData" />
      </AntCol>
      <AntCol :xs="24" :sm="24" :md="24" :lg="16" :xl="18">
        <TestReport :testData="testData" />
      </AntCol>
    </AntRow>
  </Layout>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  provide,
} from 'vue'
import { useRoute } from 'vue-router'

import {
  Row as AntRow,
  Col as AntCol,
} from 'ant-design-vue'

import Layout from '@/components/SingleWalletTesting/Layout'
import Instruction from '@/components/SingleWalletTesting/Instruction'
import ParameterForm from '@/components/SingleWalletTesting/ParameterForm'
import TestReport from '@/components/SingleWalletTesting/TestReport'
import DevHostSelect from '@/components/DevHostSelect'

import { PLATFORM_LIST } from '@/constants/singleWalletTesting'
import {
  DEFAULT_BRAND,
  getResolvedBrand,
  getTemplates,
  domainToHost,
} from '@/libs/brandFromTemplates'

export default {
  name: 'SingleWalletTesting',
  components: {
    AntRow,
    AntCol,
    Layout,
    Instruction,
    ParameterForm,
    TestReport,
    DevHostSelect,
  },
  setup() {
    const route = useRoute()

    // DevHostSelect 當前選取
    const selectedHost = ref('')
    const selectedBrand = ref('')

    const brand = computed(() => selectedBrand.value || route.meta.brand || DEFAULT_BRAND)
    provide('brand', brand)

    const testData = reactive({
      isTesting: false,
      scenarioCounts: 0,
      testedScenarioCounts: 0,
      platformData: {},
      formData: {},
      testReportData: [],
      errorData: undefined,
    })

    /** 未設定 template.swaPlatforms 時的 AWC 後備（排除 THREEOAKS） */
    const awcExcludedPlatforms = ['THREEOAKS']

    const platformList = computed(() => {
      const host = selectedHost.value || domainToHost(window.location.host)
      const matched = getTemplates().find(t => domainToHost(t.domain) === host)
        || getResolvedBrand().template
      const swaPlatforms = matched?.swaPlatforms

      if (Array.isArray(swaPlatforms) && swaPlatforms.length) {
        return swaPlatforms.reduce((acc, platformId) => {
          const platformData = PLATFORM_LIST.find(({ id }) => id === platformId)
          if (platformData) acc.push(platformData)
          return acc
        }, [])
      }

      return PLATFORM_LIST.filter(({ id }) => !awcExcludedPlatforms.includes(id))
    })

    return {
      selectedHost,
      selectedBrand,
      testData,
      platformList,
    }
  },
}
</script>

<style scoped>
.content-row {
  padding: 32px 40px;
}
</style>
